export const SYNTHETIC_ROW_IDS = {
    DASHBOARD: '__DASHBOARD__',
    QUICK_AGENTS: '__QUICK_AGENTS__',
    SETTINGS: '__SETTINGS__',
    TEMPLATES: '__TEMPLATES__',
};
//# sourceMappingURL=types.js.map